import type { PublicStats, Stats } from "@/stats/types";
import { apiClient } from "./apiClient";

export const statsGateway = {
  async getStats(): Promise<Stats> {
    return await apiClient.get("/api/stats");
  },

  async getPublicStats(): Promise<PublicStats> {
    return await apiClient.get("/api/stats/public");
  },
};
